import { render } from "./ProduitTransfertPage.vue?vue&type=template&id=15b5dc2e"
import script from "./ProduitTransfertPage.vue?vue&type=script&lang=js"
export * from "./ProduitTransfertPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__